(function() {

  // ═══════════════════════════════════════════════════════════════════════
  // CONFIG — items marked TODO must be filled in before going live.
  // See the setup checklist provided alongside this file.
  // ═══════════════════════════════════════════════════════════════════════

  var PRODUCT_HANDLE = 'purahome-filter-system';
  var DEFAULT_VARIANT_TITLE = '12 months (4 Filters)'; // 1-Year is the default selection

  // TODO: replace with the real bundle product handle once created in Shopify.
  var BUNDLE_PRODUCT_HANDLE = 'purahome-complete-water-bundle';
  var BUNDLE_ACCESSORY_LABEL = 'Aerator + Shower Filter'; // short description of what's bundled in, shown in copy

  var SUBSCRIPTION_DISCOUNT_PCT = 15;   // stacked on top of each variant's existing sale price when Auto Ship is active
  var SUBSCRIPTION_DEFAULT_ON   = true; // Auto Ship tab is selected by default, per Joel's note

  var AFTERPAY_CURRENCIES = ['AUD', 'NZD', 'USD', 'CAD', 'GBP'];
  var AFTERPAY_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/after-pay.svg?v=1752685514';

  var COLOR_NAVY        = '#1e2764';
  var COLOR_BLUE        = '#2a5bd7';
  var COLOR_BORDER_NAVY = '#1e2764';
  var COLOR_GREEN       = '#01b778';
  var COLOR_GRAY_TEXT   = '#6b7280';
  var COLOR_GRAY_BORDER = '#d8dce3';
  var COLOR_BLACK       = '#111827';
  var COLOR_UPSELL_FILL = '#eef0fc';

  // Order top → bottom: 24mo (sold out) → 12mo (best value, default) → 6mo (no badge)
  var VARIANT_ORDER = [
    '24 months (8 Filters)',
    '12 months (4 Filters)',
    '6 months (2 Filters)',
  ];

  var VARIANT_META = {
    '24 months (8 Filters)': {
      label: '2-Year Supply',
      sublabelOneTime: '(Filter System + 8 Filters)',
      sublabelAutoShip: '(8 Filters) ship every 24 months',
      badge: null,
      days: 730,
      cadenceMonths: 24,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/3_995b8e44-38a0-4e25-9471-a3a9c38e421d.png?v=1781932651'
    },
    '12 months (4 Filters)': {
      label: '1-Year Supply',
      sublabelOneTime: '(Filter System + 4 Filters)',
      sublabelAutoShip: '(4 Filters) ship every 12 months',
      badge: 'Most Popular',
      days: 365,
      cadenceMonths: 12,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/4_f83c21da-81c8-4e88-94d3-9a241f59272c.png?v=1781932650'
    },
    '6 months (2 Filters)': {
      label: '6-Month Supply',
      sublabelOneTime: '(Filter System + 2 Filters)',
      sublabelAutoShip: '(2 Filters) ship every 6 months',
      badge: null,
      days: 182,
      cadenceMonths: 6,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/5_ae454446-23b8-4170-961b-3ec598209f15.png?v=1781932650'
    }
  };

  // 24-month is a permanent sold-out anchor — 100% scarcity, no selling plan possible.
  var VARIANT_SCARCITY = {
    '24 months (8 Filters)': { pctClaimed: 100, label: 'sold out', color: '#ef4444' },
    '12 months (4 Filters)': { pctClaimed: 88,  label: 'sold out', color: '#ef4444' },
    '6 months (2 Filters)':  { pctClaimed: 52,  label: 'sold out', color: '#f97316' },
  };

  // TODO: confirm these selling plan IDs are correct for this product / still active.
  var SUBSCRIPTION_SELLING_PLANS = {
    '6 months (2 Filters)':  694262956348,
    '12 months (4 Filters)': 694263021884,
    '24 months (8 Filters)': null, // sold out — no subscription possible
  };

  // TODO: replace with the bundle product's real selling plan IDs once set up.
  var BUNDLE_SELLING_PLANS = {
    '1yr': 694346187068,
    '6mo': 694346154300
  };

  var CURRENCY_SYMBOLS = {
    'AUD': '$', 'USD': '$', 'CAD': '$', 'NZD': '$', 'SGD': '$', 'HKD': '$',
    'GBP': '\u00a3', 'EUR': '\u20ac', 'JPY': '\u00a5', 'CNY': '\u00a5', 'INR': '\u20b9',
    'CHF': 'Fr', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'ZAR': 'R',
    'MXN': '$', 'BRL': 'R$', 'AED': '\u062f.\u0625', 'THB': '\u0e3f', 'MYR': 'RM',
    'PHP': '\u20b1', 'KRW': '\u20a9', 'TRY': '\u20ba',
  };

  // ═══════════════════════════════════════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════════════════════════════════════

  var state = {
    variants: [],
    currentVariantId: null,
    currency: 'AUD',
    subscriptionActive: SUBSCRIPTION_DEFAULT_ON,
    bundle: {
      product: null,        // fetched bundle product data
      selected: false,
      option: '1yr',        // '1yr' | '6mo'
      variants: {},          // { '1yr': {id, price, compare}, '6mo': {...} }
      images: [],
      title: '',
      description: ''
    }
  };

  // Listeners registered via window.PuraHomeOffer.onChange — fired at the end
  // of every applyPricing() call so external scripts (e.g. the GemPages
  // dynamic-checkout sync script) can react to selection changes.
  var bridgeChangeListeners = [];

  // ═══════════════════════════════════════════════════════════════════════
  // HELPERS
  // ═══════════════════════════════════════════════════════════════════════

  function detectProductHandle() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
          window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.handle) {
        return window.ShopifyAnalytics.meta.product.handle;
      }
    } catch (e) {}
    try {
      var match = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
      if (match) return match[1];
    } catch (e) {}
    return PRODUCT_HANDLE;
  }

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active : 'AUD';
  }

  function getCurrencySymbol(currency) { return CURRENCY_SYMBOLS[currency] || '$'; }

  function formatMoney(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      return symbol + new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    } catch(e) { return '$' + amount.toFixed(2); }
  }

  function formatMoneyNoDecimal(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      return symbol + new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
    } catch(e) { return '$' + Math.round(amount); }
  }

  function formatPerDay(price, days, currency) {
    return getCurrencySymbol(currency) + (price / days).toFixed(2) + '/day';
  }

  function pctOff(compare, effective) {
    if (!compare || compare <= effective) return 0;
    return Math.round((1 - effective / compare) * 100);
  }

  function getCurrentVariant() {
    for (var i = 0; i < state.variants.length; i++) {
      if (state.variants[i].id == state.currentVariantId) return state.variants[i];
    }
    return null;
  }

  function getEffectivePrice(basePrice) {
    return state.subscriptionActive ? basePrice * (1 - SUBSCRIPTION_DISCOUNT_PCT / 100) : basePrice;
  }

  // Highest stackable discount % available anywhere (any variant or the bundle,
  // assuming Auto Ship is active) — used for the tab label.
  function computeMaxSavingsPct() {
    var max = 0;
    state.variants.forEach(function(v) {
      if (!v.available || !v.compare_price) return;
      var eff = v.price * (1 - SUBSCRIPTION_DISCOUNT_PCT / 100);
      var p = pctOff(v.compare_price, eff);
      if (p > max) max = p;
    });
    ['1yr', '6mo'].forEach(function(opt) {
      var bv = state.bundle.variants[opt];
      if (!bv || !bv.compare_price) return;
      var eff = bv.price * (1 - SUBSCRIPTION_DISCOUNT_PCT / 100);
      var p = pctOff(bv.compare_price, eff);
      if (p > max) max = p;
    });
    return max;
  }

  // ═══════════════════════════════════════════════════════════════════════
  // STYLES (self-contained — no dependency on external theme CSS)
  // ═══════════════════════════════════════════════════════════════════════

  function injectStyles() {
    if (document.getElementById('ph2-v4-styles')) return;
    var style = document.createElement('style');
    style.id = 'ph2-v4-styles';
    style.textContent = [
      '#ph2-top-sep{border:none;border-top:1px solid #e5e7eb !important;margin:0 0 16px !important;}',
      '#ph2-perday-hero{font-size:1.5rem;font-weight:800;color:' + COLOR_BLUE + ';line-height:1.1;margin-bottom:4px;}',
      '#ph2-perday-sub{font-size:0.82rem;color:' + COLOR_GRAY_TEXT + ';margin-bottom:16px;}',
      '.ph2-sep{border:none;border-top:1px solid #e5e7eb !important;margin:4px 0 10px !important;display:block !important;}',
      '.ph2-tab-toggle{display:flex;background:#f5f5f6;border-radius:999px;padding:4px;margin-bottom:10px;position:relative;}',
      '.ph2-tab-btn{flex:1;text-align:center;padding:11px 8px;border-radius:999px;font-size:13px;font-weight:700;cursor:pointer;color:#9ca3af;z-index:1;transition:color .2s ease;user-select:none;}',
      '.ph2-tab-btn.active{color:#fff !important;}',
      '#ph2-tab-sub.active .ph2-tab-sub-pct{color:' + COLOR_GREEN + ' !important;font-weight:800 !important;}',
      '.ph2-tab-slider{position:absolute;top:4px;left:4px;width:calc(50% - 4px);height:calc(100% - 8px);background:' + COLOR_NAVY + ' !important;border-radius:999px;transition:transform .25s ease;}',
      '.ph2-tab-toggle.sub-active .ph2-tab-slider{transform:translateX(100%);}',
      '.ph2-hidden{display:none !important;}',
      '#ph2-dynamic-strip{text-align:center;font-size:.78rem;color:' + COLOR_GRAY_TEXT + ';margin-bottom:16px;min-height:18px;}',
      '#ph2-dynamic-strip strong{color:' + COLOR_BLACK + ';}',
      '#ph2-afterpay-content{white-space:nowrap;}',
      '.ph2-ap-logo{display:inline-block !important;height:13px !important;width:auto !important;max-width:none !important;vertical-align:middle !important;margin-left:5px !important;}',
      '#ph2-autoship-reassurance{color:' + COLOR_BLACK + ';font-weight:700;font-size:11px;}',
      '#ph2-supply-heading{font-size:16px;font-weight:700;color:' + COLOR_BLACK + ';margin-bottom:12px;}',
      '#ph2-supply-heading span{color:' + COLOR_NAVY + ';}',
      '.ph2-card{position:relative;border:1.5px solid ' + COLOR_GRAY_BORDER + ' !important;border-radius:14px;padding:14px 16px;background:#fff !important;cursor:pointer;margin-bottom:14px;transition:border-color .15s ease,background .15s ease;overflow:visible;}',
      '.ph2-card.ph2-selected{border-color:#4f46e5 !important;background:' + COLOR_UPSELL_FILL + ' !important;}',
      '.ph2-card.ph2-sold-out{cursor:not-allowed;background:#e8e9ee !important;border-color:#dcdee6 !important;}',
      '.ph2-card-row-inner{display:flex;align-items:center;gap:14px;width:100%;}',
      '.ph2-sold-out .ph2-card-row-inner{filter:blur(2.5px);opacity:.65;}',
      '.ph2-sold-out .ph2-card-img{filter:grayscale(1);}',
      '.ph2-sold-out-overlay{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:3;pointer-events:none;}',
      '.ph2-sold-pill-center{flex:0 0 auto;font-size:11.5px;font-weight:800;letter-spacing:.03em;background:' + COLOR_NAVY + ' !important;color:#fff !important;padding:8px 20px;border-radius:8px;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,.25);}',
      '.ph2-corner-ribbon{position:absolute;top:-8px;right:14px;font-size:9px;font-weight:700;letter-spacing:.03em;padding:3px 11px;border-radius:6px;background:' + COLOR_GREEN + ' !important;color:#fff !important;z-index:2;box-shadow:0 1px 3px rgba(0,0,0,0.15);}',
      '.ph2-card-img{flex:0 0 auto;width:56px;height:56px;object-fit:contain;}',
      '.ph2-card-mid{flex:1 1 auto;min-width:0;}',
      '.ph2-card-titlerow{display:flex;align-items:center;gap:7px;flex-wrap:wrap;}',
      '.ph2-card-label{font-weight:700;font-size:15.5px;color:' + COLOR_NAVY + ' !important;}',
      '.ph2-pct-pill{font-size:11px;font-weight:800;background:' + COLOR_GREEN + ' !important;color:#fff !important;padding:2.5px 9px;border-radius:20px;white-space:nowrap;}',
      '.ph2-card-sublabel{font-size:12px;color:' + COLOR_GRAY_TEXT + ';margin-top:2px;}',
      '.ph2-card-right{flex:0 0 auto;text-align:right;}',
      '.ph2-card-compare{font-size:12px;color:#9ca3af;text-decoration:line-through;}',
      '.ph2-card-price{font-size:19px;font-weight:800;color:' + COLOR_BLUE + ' !important;line-height:1.1;}',
      '.ph2-card-perday{font-size:11px;color:' + COLOR_GREEN + ' !important;font-weight:700;margin-top:3px;}',
      '.ph2-pct-pill.ph2-outline{background:transparent !important;color:' + COLOR_GREEN + ' !important;border:1.5px solid ' + COLOR_GREEN + ' !important;}',
      '.ph2-stock-banner{display:flex;align-items:center;gap:7px;margin:2px 0 18px;font-size:11.5px;font-weight:600;color:#b91c1c;}',
      '.ph2-stock-dot{width:7px;height:7px;border-radius:50%;background:#ef4444;flex:0 0 auto;animation:ph2-pulse 1.4s infinite;}',
      '@keyframes ph2-pulse{0%{box-shadow:0 0 0 0 rgba(239,68,68,.6);}70%{box-shadow:0 0 0 6px rgba(239,68,68,0);}100%{box-shadow:0 0 0 0 rgba(239,68,68,0);}}',
      '.ph2-bundle-heading{font-size:16px;font-weight:700;color:' + COLOR_BLACK + ';margin-bottom:10px;}',
      '.ph2-bundle-card{position:relative;border:1.5px dashed #4f46e5 !important;border-radius:14px;padding:14px 16px;background:' + COLOR_UPSELL_FILL + ' !important;cursor:pointer;margin-bottom:16px;transition:background .15s ease;overflow:visible;}',
      '.ph2-bundle-card.ph2-selected{background:#e4e8fd !important;}',
      '.ph2-bundle-ribbon{position:absolute;top:-8px;right:14px;background:' + COLOR_GREEN + ' !important;color:#fff !important;font-size:9px;font-weight:700;letter-spacing:.03em;padding:3px 11px;border-radius:6px;box-shadow:0 1px 3px rgba(0,0,0,0.15);}',
      '.ph2-bundle-top-row{display:flex;align-items:flex-start;gap:14px;}',
      '.ph2-bundle-check{width:22px;height:22px;border-radius:6px;border:2px solid #4f46e5 !important;flex:0 0 auto;display:flex;align-items:center;justify-content:center;background:#fff !important;margin-top:2px;}',
      '.ph2-bundle-check.ph2-checked{background:#4f46e5 !important;}',
      '.ph2-bundle-check svg{display:none;width:14px;height:14px;}',
      '.ph2-bundle-check.ph2-checked svg{display:block;}',
      '.ph2-bundle-img{flex:0 0 auto;width:56px;height:56px;object-fit:contain;background:#fff;border-radius:8px;}',
      '.ph2-bundle-img-col{flex:0 0 auto;display:flex;flex-direction:column;align-items:center;gap:6px;}',
      '.ph2-bundle-info-btn{display:none;width:20px;height:20px;border-radius:50%;background:' + COLOR_NAVY + ' !important;color:#fff !important;border:none;font-size:11px;font-weight:700;font-style:italic;cursor:pointer;align-items:center;justify-content:center;line-height:1;padding:0;}',
      '.ph2-bundle-card.ph2-selected .ph2-bundle-info-btn{display:flex;}',
      '.ph2-gallery-modal{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(17,24,39,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;}',
      '.ph2-gallery-box{background:#fff;border-radius:14px;width:100%;max-width:520px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;}',
      '.ph2-gallery-header{display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid ' + COLOR_GRAY_BORDER + ';flex-shrink:0;}',
      '.ph2-gallery-close{border:none;background:none;font-size:18px;color:' + COLOR_GRAY_TEXT + ';cursor:pointer;padding:4px 8px;}',
      '.ph2-gallery-stage{position:relative;background:#f8fafc;display:flex;align-items:center;justify-content:center;aspect-ratio:1/1;overflow:hidden;padding:28px;box-sizing:border-box;}',
      '.ph2-gallery-stage img{width:100%;height:100%;object-fit:contain;}',
      '.ph2-gallery-nav{position:absolute;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;background:rgba(255,255,255,.92);border:none;color:' + COLOR_NAVY + ';font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;}',
      '.ph2-gallery-nav-prev{left:10px;}',
      '.ph2-gallery-nav-next{right:10px;}',
      '.ph2-gallery-dots{display:flex;justify-content:center;gap:6px;padding:10px 0;}',
      '.ph2-gallery-dot{width:6px;height:6px;border-radius:50%;background:' + COLOR_GRAY_BORDER + ';}',
      '.ph2-gallery-dot.ph2-active{background:' + COLOR_NAVY + ';}',
      '.ph2-gallery-body{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px 18px;}',
      '.ph2-gallery-title{font-size:16px;font-weight:700;color:' + COLOR_NAVY + ';margin-bottom:8px;}',
      '.ph2-gallery-desc{font-size:13px;color:' + COLOR_GRAY_TEXT + ';line-height:1.6;}',
      '.ph2-bundle-mid{flex:1 1 auto;min-width:0;}',
      '.ph2-bundle-label{font-weight:700;font-size:15px;color:' + COLOR_NAVY + ' !important;}',
      '.ph2-bundle-badge-row{margin-top:5px;}',
      '.ph2-bundle-list{list-style:none;margin:8px 0 0;padding:0;font-size:12px;color:' + COLOR_GRAY_TEXT + ';line-height:1.6;display:none;}',
      '.ph2-bundle-card.ph2-selected .ph2-bundle-list{display:block;}',
      '.ph2-bundle-list li{position:relative;padding-left:14px;}',
      '.ph2-bundle-list li::before{content:"\u2022";position:absolute;left:0;color:' + COLOR_BLUE + ';font-weight:700;}',
      '.ph2-bundle-right{flex:0 0 auto;text-align:right;}',
      '.ph2-bundle-price{font-size:18px;font-weight:800;color:' + COLOR_BLUE + ' !important;}',
      '.ph2-bundle-options{display:none;margin-top:12px;padding-top:12px;border-top:1px solid ' + COLOR_GRAY_BORDER + ';gap:8px;}',
      '.ph2-bundle-card.ph2-selected .ph2-bundle-options{display:flex;}',
      '.ph2-bundle-opt{flex:1;text-align:center;padding:9px 6px;border-radius:9px;border:1.5px solid ' + COLOR_GRAY_BORDER + ' !important;background:#fff !important;font-size:12.5px;font-weight:700;color:' + COLOR_NAVY + ' !important;cursor:pointer;}',
      '.ph2-bundle-opt.ph2-active{border-color:#4f46e5 !important;background:#4f46e5 !important;color:#fff !important;}',
      '.ph2-trust-row{display:flex;justify-content:space-between;gap:8px;margin:20px 0 4px;}',
      '.ph2-trust-col{display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1 1 0;text-align:center;border:1.5px solid ' + COLOR_GRAY_BORDER + ' !important;border-radius:12px;padding:14px 8px;}',
      '.ph2-trust-icon{color:' + COLOR_BLUE + ';margin-bottom:8px;display:flex;align-items:center;justify-content:center;}',
      '.ph2-trust-label{font-size:12px;font-weight:700;color:' + COLOR_BLUE + ' !important;line-height:1.25;}',
      'button.ph2-atc-btn{display:block !important;width:100% !important;padding:15px !important;background:' + COLOR_BLUE + ' !important;color:#fff !important;font-weight:700 !important;font-size:15px !important;text-align:center !important;border:none !important;border-radius:10px !important;cursor:pointer !important;margin-top:6px !important;box-shadow:none !important;line-height:1.2 !important;}',
      '.ph2-atc-pct{font-weight:900 !important;}',
      'button.ph2-atc-btn:disabled{opacity:.7 !important;cursor:default !important;}',
      '@media (max-width:480px){.ph2-card{padding:10px 12px;}.ph2-card-img{width:46px;height:46px;}.ph2-card-label{font-size:14.5px;}.ph2-card-price{font-size:16px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  // ═══════════════════════════════════════════════════════════════════════
  // BUILD: price block, tab toggle, dynamic strip
  // ═══════════════════════════════════════════════════════════════════════

  function buildPriceBlock() {
    var existing = document.getElementById('ph2-price-block');
    if (existing) existing.parentNode.removeChild(existing);

    var block = document.createElement('div');
    block.id = 'ph2-price-block';

    var topSep = document.createElement('hr');
    topSep.id = 'ph2-top-sep';
    block.appendChild(topSep);

    var perDayHero = document.createElement('div');
    perDayHero.id = 'ph2-perday-hero';
    block.appendChild(perDayHero);

    var perDaySub = document.createElement('div');
    perDaySub.id = 'ph2-perday-sub';
    block.appendChild(perDaySub);

    var sep = document.createElement('hr');
    sep.className = 'ph2-sep';
    block.appendChild(sep);

    // Tab toggle
    var tabToggle = document.createElement('div');
    tabToggle.className = 'ph2-tab-toggle';
    tabToggle.id = 'ph2-tab-toggle';

    var slider = document.createElement('div');
    slider.className = 'ph2-tab-slider';
    tabToggle.appendChild(slider);

    var tabOneTime = document.createElement('div');
    tabOneTime.className = 'ph2-tab-btn';
    tabOneTime.id = 'ph2-tab-onetime';
    tabOneTime.textContent = 'One-Time Purchase';
    tabToggle.appendChild(tabOneTime);

    var tabSub = document.createElement('div');
    tabSub.className = 'ph2-tab-btn';
    tabSub.id = 'ph2-tab-sub';
    var tabSubText = document.createElement('span');
    tabSubText.innerHTML = '<span id="ph2-tab-sub-label">Auto Ship &amp; Save </span><span id="ph2-tab-sub-pct" class="ph2-tab-sub-pct"></span>';
    tabSub.appendChild(tabSubText);
    tabToggle.appendChild(tabSub);

    tabOneTime.addEventListener('click', function() { state.subscriptionActive = false; applyPricing(); });
    tabSub.addEventListener('click', function() { state.subscriptionActive = true; applyPricing(); });

    block.appendChild(tabToggle);

    // Dynamic strip: Afterpay <-> Auto Ship reassurance, same slot
    var dynStrip = document.createElement('div');
    dynStrip.id = 'ph2-dynamic-strip';

    var apContent = document.createElement('span');
    apContent.id = 'ph2-afterpay-content';
    apContent.innerHTML = 'or 4 payments of <strong id="ph2-afterpay-amount"></strong> with' +
      '<img src="' + AFTERPAY_LOGO_URL + '" alt="Afterpay" class="ph2-ap-logo">';
    dynStrip.appendChild(apContent);

    var autoshipText = document.createElement('span');
    autoshipText.id = 'ph2-autoship-reassurance';
    autoshipText.textContent = '\ud83d\udd04 Auto-ships \u00b7 Cancel anytime \u00b7 No commitment';
    autoshipText.classList.add('ph2-hidden');
    dynStrip.appendChild(autoshipText);

    block.appendChild(dynStrip);

    var picker = document.getElementById('ph2-picker');
    picker.parentNode.insertBefore(block, picker);
  }

  function buildSupplyHeading() {
    var existing = document.getElementById('ph2-supply-heading');
    if (existing) existing.parentNode.removeChild(existing);

    var heading = document.createElement('div');
    heading.id = 'ph2-supply-heading';
    heading.innerHTML = 'Filter Supply: <span id="ph2-supply-heading-value"></span>';

    var picker = document.getElementById('ph2-picker');
    picker.parentNode.insertBefore(heading, picker);
  }

  // ═══════════════════════════════════════════════════════════════════════
  // BUILD: variant cards
  // ═══════════════════════════════════════════════════════════════════════

  function highlightCard(variantId, container) {
    container.querySelectorAll('.ph2-card').forEach(function(c) {
      c.classList.toggle('ph2-selected', !state.bundle.selected && c.getAttribute('data-variant-id') == variantId);
    });
  }

  function buildCards(variants, currency, container) {
    container.innerHTML = '';

    variants = variants.filter(function(v) { return VARIANT_ORDER.indexOf(v.title) !== -1; });
    variants.sort(function(a, b) {
      var ai = VARIANT_ORDER.indexOf(a.title), bi = VARIANT_ORDER.indexOf(b.title);
      if (ai === -1) ai = 999; if (bi === -1) bi = 999;
      return ai - bi;
    });

    state.variants = variants;
    state.currency = currency;

    var defaultVariant = null;
    variants.forEach(function(v) { if (v.title === DEFAULT_VARIANT_TITLE && v.available) defaultVariant = v; });
    if (!defaultVariant) { for (var i = 0; i < variants.length; i++) { if (variants[i].available) { defaultVariant = variants[i]; break; } } }
    if (!defaultVariant) defaultVariant = variants[0];
    state.currentVariantId = defaultVariant.id;

    variants.forEach(function(variant) {
      var meta = VARIANT_META[variant.title] || { label: variant.title, days: 365 };
      var isSoldOut = !variant.available;

      var card = document.createElement('div');
      card.className = 'ph2-card' + (isSoldOut ? ' ph2-sold-out' : '');
      card.setAttribute('data-variant-id', variant.id);
      card.setAttribute('data-variant-title', variant.title);

      if (meta.badge && !isSoldOut) {
        var ribbon = document.createElement('div');
        ribbon.className = 'ph2-corner-ribbon';
        ribbon.textContent = meta.badge.toUpperCase();
        card.appendChild(ribbon);
      }

      var inner = document.createElement('div');
      inner.className = 'ph2-card-row-inner';

      var img = document.createElement('img');
      img.className = 'ph2-card-img';
      img.src = meta.image;
      img.alt = meta.label;
      inner.appendChild(img);

      var mid = document.createElement('div');
      mid.className = 'ph2-card-mid';

      var titleRow = document.createElement('div');
      titleRow.className = 'ph2-card-titlerow';

      var labelEl = document.createElement('span');
      labelEl.className = 'ph2-card-label';
      labelEl.textContent = meta.label;
      titleRow.appendChild(labelEl);

      if (!isSoldOut) {
        var pctPill = document.createElement('span');
        pctPill.className = 'ph2-pct-pill' + (variant.title === '6 months (2 Filters)' ? ' ph2-outline' : '');
        titleRow.appendChild(pctPill);
      }
      mid.appendChild(titleRow);

      var sublabelEl = document.createElement('div');
      sublabelEl.className = 'ph2-card-sublabel';
      mid.appendChild(sublabelEl);

      inner.appendChild(mid);

      var right = document.createElement('div');
      right.className = 'ph2-card-right';
      var compareEl = document.createElement('div');
      compareEl.className = 'ph2-card-compare';
      right.appendChild(compareEl);
      var priceEl = document.createElement('div');
      priceEl.className = 'ph2-card-price';
      right.appendChild(priceEl);
      var perDayEl = document.createElement('div');
      perDayEl.className = 'ph2-card-perday';
      right.appendChild(perDayEl);
      inner.appendChild(right);

      card.appendChild(inner);

      if (isSoldOut) {
        var overlay = document.createElement('div');
        overlay.className = 'ph2-sold-out-overlay';
        var soldPillCenter = document.createElement('span');
        soldPillCenter.className = 'ph2-sold-pill-center';
        soldPillCenter.textContent = 'SOLD OUT';
        overlay.appendChild(soldPillCenter);
        card.appendChild(overlay);
      }

      card.addEventListener('click', function() {
        if (isSoldOut) return;
        state.currentVariantId = variant.id;
        state.bundle.selected = false;
        highlightCard(variant.id, container);
        applyPricing();
      });

      container.appendChild(card);
    });

    highlightCard(defaultVariant.id, container);
    applyPricing();
  }

  // ═══════════════════════════════════════════════════════════════════════
  // BUILD: stock banner + bundle option + ATC
  // ═══════════════════════════════════════════════════════════════════════

  function buildStockBanner() {
    var container = document.getElementById('ph2-cta');
    if (!container) return;
    var banner = document.createElement('div');
    banner.className = 'ph2-stock-banner';
    var dot = document.createElement('span');
    dot.className = 'ph2-stock-dot';
    banner.appendChild(dot);
    var text = document.createElement('span');
    text.innerHTML = '<strong>SELLING FAST</strong> \u2014 Secure yours now before we sell out.';
    banner.appendChild(text);
    container.appendChild(banner);
  }

  function buildBundleOption() {
    var container = document.getElementById('ph2-cta');
    if (!container) return;

    var heading = document.createElement('div');
    heading.className = 'ph2-bundle-heading';
    heading.textContent = 'Or Grab Our Best-Selling Bundle';
    container.appendChild(heading);

    var card = document.createElement('div');
    card.className = 'ph2-bundle-card';
    card.id = 'ph2-bundle-card';

    var ribbon = document.createElement('div');
    ribbon.className = 'ph2-bundle-ribbon';
    ribbon.textContent = 'BEST VALUE';
    card.appendChild(ribbon);

    var topRow = document.createElement('div');
    topRow.className = 'ph2-bundle-top-row';

    var check = document.createElement('div');
    check.className = 'ph2-bundle-check';
    check.id = 'ph2-bundle-check';
    check.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="5 12 10 17 19 7"/></svg>';
    topRow.appendChild(check);

    var imgCol = document.createElement('div');
    imgCol.className = 'ph2-bundle-img-col';

    var img = document.createElement('img');
    img.className = 'ph2-bundle-img';
    img.id = 'ph2-bundle-img';
    img.alt = 'Complete Water Bundle';
    imgCol.appendChild(img);

    var infoBtn = document.createElement('button');
    infoBtn.type = 'button';
    infoBtn.className = 'ph2-bundle-info-btn';
    infoBtn.setAttribute('aria-label', 'View bundle photos and details');
    infoBtn.textContent = 'i';
    infoBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      openBundleGalleryModal();
    });
    imgCol.appendChild(infoBtn);

    topRow.appendChild(imgCol);

    var mid = document.createElement('div');
    mid.className = 'ph2-bundle-mid';
    var label = document.createElement('div');
    label.className = 'ph2-bundle-label';
    label.textContent = 'Complete Water Bundle';
    mid.appendChild(label);

    var badgeRow = document.createElement('div');
    badgeRow.className = 'ph2-bundle-badge-row';
    var pctPill = document.createElement('span');
    pctPill.className = 'ph2-pct-pill';
    pctPill.id = 'ph2-bundle-pct-pill';
    badgeRow.appendChild(pctPill);
    mid.appendChild(badgeRow);

    var bundleList = document.createElement('ul');
    bundleList.className = 'ph2-bundle-list';
    bundleList.id = 'ph2-bundle-list';
    mid.appendChild(bundleList);

    topRow.appendChild(mid);

    var right = document.createElement('div');
    right.className = 'ph2-bundle-right';
    var compareEl = document.createElement('div');
    compareEl.className = 'ph2-card-compare';
    compareEl.id = 'ph2-bundle-compare';
    right.appendChild(compareEl);
    var priceEl = document.createElement('div');
    priceEl.className = 'ph2-bundle-price';
    priceEl.id = 'ph2-bundle-price';
    right.appendChild(priceEl);
    topRow.appendChild(right);

    card.appendChild(topRow);

    var options = document.createElement('div');
    options.className = 'ph2-bundle-options';
    options.id = 'ph2-bundle-options';

    var opt1yr = document.createElement('div');
    opt1yr.className = 'ph2-bundle-opt';
    opt1yr.setAttribute('data-opt', '1yr');
    opt1yr.textContent = '1-Year Supply';
    options.appendChild(opt1yr);

    var opt6mo = document.createElement('div');
    opt6mo.className = 'ph2-bundle-opt';
    opt6mo.setAttribute('data-opt', '6mo');
    opt6mo.textContent = '6-Month Supply';
    options.appendChild(opt6mo);

    card.appendChild(options);

    card.addEventListener('click', function(e) {
      if (e.target.closest('.ph2-bundle-opt')) return;
      state.bundle.selected = !state.bundle.selected;
      var cardsContainer = document.getElementById('ph2-cards');
      if (cardsContainer) highlightCard(state.currentVariantId, cardsContainer);
      applyPricing();
    });

    [opt1yr, opt6mo].forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        state.bundle.option = opt.getAttribute('data-opt');
        applyPricing();
      });
    });

    container.appendChild(card);
  }

  function openBundleGalleryModal() {
    var images = state.bundle.images.length > 0 ? state.bundle.images : [document.getElementById('ph2-bundle-img') ? document.getElementById('ph2-bundle-img').src : ''];
    var idx = 0;

    var existing = document.getElementById('ph2-gallery-modal');
    if (existing) existing.parentNode.removeChild(existing);

    var modal = document.createElement('div');
    modal.id = 'ph2-gallery-modal';
    modal.className = 'ph2-gallery-modal';

    var box = document.createElement('div');
    box.className = 'ph2-gallery-box';

    var header = document.createElement('div');
    header.className = 'ph2-gallery-header';
    var headerTitle = document.createElement('div');
    headerTitle.style.cssText = 'font-size:14px;font-weight:700;color:' + COLOR_NAVY + ';';
    headerTitle.textContent = 'Bundle Photos';
    header.appendChild(headerTitle);
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ph2-gallery-close';
    closeBtn.textContent = '\u2715';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.addEventListener('click', function() { modal.parentNode.removeChild(modal); });
    header.appendChild(closeBtn);
    box.appendChild(header);

    var stage = document.createElement('div');
    stage.className = 'ph2-gallery-stage';
    var stageImg = document.createElement('img');
    stage.appendChild(stageImg);

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'ph2-gallery-nav ph2-gallery-nav-prev';
    prevBtn.innerHTML = '\u2039';
    prevBtn.setAttribute('aria-label', 'Previous image');
    stage.appendChild(prevBtn);

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'ph2-gallery-nav ph2-gallery-nav-next';
    nextBtn.innerHTML = '\u203a';
    nextBtn.setAttribute('aria-label', 'Next image');
    stage.appendChild(nextBtn);

    box.appendChild(stage);

    var dots = document.createElement('div');
    dots.className = 'ph2-gallery-dots';
    var dotEls = images.map(function() {
      var d = document.createElement('span');
      d.className = 'ph2-gallery-dot';
      dots.appendChild(d);
      return d;
    });
    if (images.length > 1) box.appendChild(dots);

    function render() {
      stageImg.src = images[idx];
      dotEls.forEach(function(d, i) { d.classList.toggle('ph2-active', i === idx); });
    }
    prevBtn.addEventListener('click', function() { idx = (idx - 1 + images.length) % images.length; render(); });
    nextBtn.addEventListener('click', function() { idx = (idx + 1) % images.length; render(); });
    if (images.length <= 1) { prevBtn.style.display = 'none'; nextBtn.style.display = 'none'; }
    render();

    var body = document.createElement('div');
    body.className = 'ph2-gallery-body';
    var titleEl = document.createElement('div');
    titleEl.className = 'ph2-gallery-title';
    titleEl.textContent = state.bundle.title || 'Complete Water Bundle';
    body.appendChild(titleEl);
    var descEl = document.createElement('div');
    descEl.className = 'ph2-gallery-desc';
    descEl.innerHTML = state.bundle.description || 'Everything you need for whole-home water filtration in one bundle.';
    body.appendChild(descEl);
    box.appendChild(body);

    modal.appendChild(box);
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.parentNode.removeChild(modal); });
    document.body.appendChild(modal);
  }

  function buildAtcButton() {
    var container = document.getElementById('ph2-cta');
    if (!container) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ph2-atc-btn';
    btn.id = 'ph2-atc-btn';
    btn.innerHTML = 'Protect My Home &amp; Save';
    btn.addEventListener('click', handleAddToCartClick);
    container.appendChild(btn);
  }

  function buildTrustBadges() {
    var container = document.getElementById('ph2-cta');
    if (!container) return;
    var row = document.createElement('div');
    row.className = 'ph2-trust-row';
    var badges = [
      { label: 'Free Shipping',      svg: '<rect x="1" y="6" width="13" height="10"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>' },
      { label: 'Free Returns',       svg: '<path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 9 8 9"/>' },
      { label: '100 Day Money Back', svg: '<path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z"/><polyline points="9 12 11 14 15 10"/>' }
    ];
    badges.forEach(function(b) {
      var col = document.createElement('div');
      col.className = 'ph2-trust-col';
      var iconBox = document.createElement('div');
      iconBox.className = 'ph2-trust-icon';
      iconBox.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + b.svg + '</svg>';
      col.appendChild(iconBox);
      var label = document.createElement('div');
      label.className = 'ph2-trust-label';
      label.textContent = b.label;
      col.appendChild(label);
      row.appendChild(col);
    });
    container.appendChild(row);
  }

  var LAB_TEST_PDF_URL = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/PuraHome.pdf?v=1781945780';

  function openLabTestPopup() {
    var existing = document.getElementById('ph2-modal-labtest');
    if (existing) existing.parentNode.removeChild(existing);

    var modal = document.createElement('div');
    modal.id = 'ph2-modal-labtest';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:#f9fafb;z-index:99999;display:flex;flex-direction:column;overflow:hidden;box-sizing:border-box;';

    var header = document.createElement('div');
    header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:14px 16px;background:#fff;border-bottom:1px solid #e5e7eb;flex-shrink:0;position:sticky;top:0;z-index:10;box-shadow:0 1px 4px rgba(0,0,0,0.06);';

    var titleEl = document.createElement('div');
    titleEl.style.cssText = 'font-size:15px;font-weight:700;color:' + COLOR_NAVY + ';';
    titleEl.textContent = 'Independent Lab Results';
    header.appendChild(titleEl);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.innerHTML = '\u2715';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.style.cssText = 'border:none;background:#f3f4f6;border-radius:50%;width:32px;height:32px;font-size:14px;color:#6b7280;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;';
    closeBtn.addEventListener('click', function() { document.body.style.overflow = ''; document.body.removeChild(modal); });
    header.appendChild(closeBtn);
    modal.appendChild(header);

    var body = document.createElement('div');
    body.style.cssText = 'flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:16px;max-width:700px;width:100%;margin:0 auto;box-sizing:border-box;';

    var heroHtml = '<div style="text-align:center;margin-bottom:18px;"><div style="font-size:20px;font-weight:800;color:#111827;margin-bottom:6px;line-height:1.3;">Independent lab testing.<br>Real results.</div><div style="font-size:13px;color:#6b7280;line-height:1.5;">Water purified by PuraHome, tested by an accredited third-party laboratory.</div></div>';

    var statsHtml = '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:14px;">';
    [{num:'14',lbl:'Parameters tested'},{num:'14/14',lbl:'Passed'},{num:'CMA',lbl:'Accredited lab'},{num:'2029',lbl:'Valid until'}].forEach(function(s) {
      statsHtml += '<div style="background:#fff;border-radius:10px;padding:10px 6px;text-align:center;border:1px solid #e5e7eb;"><div style="font-size:16px;font-weight:700;color:' + COLOR_BLUE + ';">' + s.num + '</div><div style="font-size:10px;color:#6b7280;margin-top:2px;line-height:1.3;">' + s.lbl + '</div></div>';
    });
    statsHtml += '</div>';

    var certHtml = '<div style="background:#f0fdf4;border-radius:10px;padding:10px 12px;display:flex;gap:8px;align-items:flex-start;margin-bottom:14px;"><span style="font-size:16px;flex-shrink:0;">\u2705</span><div style="font-size:11px;color:#166534;line-height:1.6;"><strong>CMA Accredited \u2014 Report No. XYS202500786</strong><br>Henan TaiQing Quality Testing Co., LTD \u00b7 CMA No. 231600140601 \u00b7 Valid until Nov 7, 2029 \u00b7 Tested June 2025 \u00b7 GB 5749-2022 standard.</div></div>';
    var noteHtml = '<div style="background:#eff6ff;border-left:3px solid ' + COLOR_BLUE + ';padding:9px 12px;font-size:11px;color:#374151;line-height:1.6;margin-bottom:16px;border-radius:0 8px 8px 0;"><strong>"Not detected"</strong> means the contaminant fell below the instrument\u2019s detection threshold \u2014 the most sensitive measurement available. These are not estimates.</div>';
    var sectionLabelHtml = '<div style="font-size:10px;font-weight:700;color:#9ca3af;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:10px;">Results by contaminant category</div>';

    function nd(sub) { return '<span style="display:inline-block;background:#eff6ff;color:' + COLOR_BLUE + ';font-size:11px;font-weight:600;padding:2px 7px;border-radius:20px;white-space:nowrap;">Not detected</span>' + (sub ? '<div style="font-size:10px;color:#9ca3af;margin-top:2px;">' + sub + '</div>' : ''); }
    function pass(val, sub) { return '<span style="display:inline-block;background:#f0fdf4;color:#16a34a;font-size:11px;font-weight:600;padding:2px 7px;border-radius:20px;white-space:nowrap;">' + val + '</span>' + (sub ? '<div style="font-size:10px;color:#9ca3af;margin-top:2px;">' + sub + '</div>' : ''); }
    function conf() { return '<span style="display:inline-block;background:#f0fdf4;color:#16a34a;font-size:11px;font-weight:600;padding:2px 7px;border-radius:20px;">\u2713 Pass</span>'; }
    function pct2(val, cite) { return '<span style="display:inline-block;font-size:13px;font-weight:700;color:#16a34a;">' + val + '</span>' + (cite ? '<div style="font-size:10px;color:#9ca3af;margin-top:2px;line-height:1.3;">' + cite + '</div>' : ''); }
    function red(t) { return '<span style="font-size:11px;color:#dc2626;line-height:1.4;">' + t + '</span>'; }
    function grey(t) { return '<span style="font-size:11px;color:#6b7280;">' + t + '</span>'; }
    function dash() { return '<span style="font-size:13px;color:#9ca3af;">\u2014</span>'; }

    function makeTable(rows) {
      var th = function(t, w) { return '<th style="text-align:left;padding:6px 6px;color:#9ca3af;font-weight:500;font-size:10px;border-bottom:1px solid #e5e7eb;white-space:nowrap;' + (w ? 'width:' + w + ';' : '') + '">' + t + '</th>'; };
      var h = '<div style="overflow-x:auto;-webkit-overflow-scrolling:touch;"><table style="width:100%;border-collapse:collapse;font-size:12px;min-width:420px;"><thead><tr>' + th('Contaminant','22%') + th('Lab result','22%') + th('Health concern','24%') + th('Media removal','20%') + th('Verdict','12%') + '</tr></thead><tbody>';
      rows.forEach(function(r) { h += '<tr><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;font-weight:600;color:#111827;font-size:12px;vertical-align:top;">' + r[0] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[1] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[2] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[3] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[4] + '</td></tr>'; });
      h += '</tbody></table></div>';
      return h;
    }

    var sections = [
      { icon: '\u2697\ufe0f', title: 'Heavy metals', open: true, badge: null, sub: 'Lead, mercury, arsenic, cadmium, chromium, iron, manganese', note: '<strong>Filtration media:</strong> Activated carbon block + KDF copper-zinc alloy. KDF operates via electrochemical redox \u2014 heavy metals are rendered insoluble and trapped within the media matrix. <strong>Published research:</strong> Ott et al. (2000) demonstrated KDF media achieving 95\u201399% lead reduction in controlled flow-through conditions.', rows: [['Lead',nd('<0.07 \u00b5g/L'),red('Brain and nervous system damage'),pct2('95\u201399%','KDF / carbon block (NSF/ANSI 53)'),conf()],['Mercury',nd('<0.1 \u00b5g/L'),red('Neurological damage'),pct2('95\u201399%','KDF redox reaction (Ott et al., 2000)'),conf()],['Arsenic',pass('0.00053 mg/L','Limit: \u22640.01 mg/L'),red('Cancer'),pct2('~98%','Activated carbon + KDF (Water Research, 2018)'),conf()],['Cadmium',nd('<0.06 \u00b5g/L'),red('Bone density and kidney damage'),pct2('95\u201399%','KDF / carbon block (NSF/ANSI 53)'),conf()],['Chromium (hex)',nd('<0.004 mg/L'),red('Cancer'),pct2('95\u201399%','KDF redox (Crittenden et al., 2012)'),conf()],['Iron',nd('<4.5 \u00b5g/L'),grey('Organ stress at high levels'),pct2('>99%','Mechanical + KDF'),conf()],['Manganese',pass('0.00070 mg/L','Limit: \u22640.1 mg/L'),red('Cognitive effects'),pct2('95\u201399%','KDF oxidation-reduction (Crittenden et al., 2012)'),conf()]] },
      { icon: '\ud83d\udca7', title: 'Chemical disinfectants & fluoride', open: false, badge: null, sub: 'Chlorine, fluoride, odour, taste', note: '<strong>Filtration media:</strong> Coconut shell activated carbon (CTO grade). Activated carbon adsorption is globally recognised as best-available technology for chlorine removal. <strong>Published research:</strong> WHO Guidelines for Drinking-water Quality (4th ed., 2022) confirm activated carbon achieves 98\u201399% chlorine reduction.', rows: [['Chlorine (free)',pass('0.01 mg/L','Very low residual'),red('Cancer-linked disinfection byproducts'),pct2('98\u201399%','Activated carbon CTO (WHO, 2022)'),grey('Data recorded')],['Fluoride',nd('<0.1 mg/L'),red('Dental and skeletal fluorosis'),pct2('90\u201398%','Mineral adsorption media (Water Research, 2023)'),conf()],['Odour & taste',nd('None detected'),grey('Quality indicator'),pct2('98\u201399%','Coconut shell carbon (NSF/ANSI 42)'),conf()]] },
      { icon: '\ud83e\udda0', title: 'Bacteria & microorganisms', open: false, badge: null, sub: 'E. coli, total colony count', note: '<strong>Filtration media:</strong> KDF media is bacteriostatic \u2014 it inhibits bacterial growth within the filter. <strong>Published research:</strong> KDF media confirmed to inhibit growth of E. coli and Pseudomonas (Ott et al., 2000; Silver et al., 1999).', rows: [['E. coli',nd(''),red('Severe gastrointestinal illness'),pct2('>99%','KDF bacteriostatic action (Ott et al., 2000)'),conf()],['Total colony count',nd('Limit: \u2264100 CFU/mL'),red('General microbial contamination'),pct2('>99%','Multi-barrier filtration (WHO, 2022)'),conf()]] },
      { icon: '\ud83d\udd2c', title: 'Physical properties', open: false, badge: null, sub: 'Turbidity, visible particles', note: '<strong>Filtration media:</strong> Non-woven mechanical pre-filter acts as a physical size-exclusion barrier, blocking sediment, rust, and visible particles.', rows: [['Turbidity',pass('<1 NTU','Limit: \u22641 NTU'),grey('Sediment and particle load indicator'),pct2('90\u201399%','Mechanical pre-filtration (NSF/ANSI 42)'),conf()],['Visible particles',nd('None detected'),grey('Quality indicator'),pct2('>99%','Size-exclusion mechanical filter'),conf()]] },
      { icon: '\ud83e\uddea', title: 'PFAS & microplastics', open: false, badge: null, sub: 'PFOA \u00b7 PFOS \u00b7 PFAS compounds \u00b7 microplastic particles', note: '<strong>Filtration media:</strong> Activated carbon block (ACB) is the primary PFAS-reduction media, confirmed effective via size exclusion and adsorption. Microplastic removal via mechanical pre-filtration and carbon block pore structure. <strong>Published research:</strong> Activated carbon block shown to reduce PFOA/PFOS by 73\u201399% depending on influent concentration (Appleman et al., 2014; Dickenson & Higgins, 2016). NSF/ANSI 53 & 58 certify ACB filters for PFAS reduction. Microplastic removal via ACB confirmed at >95% for particles >1\u00b5m (Zuccarini et al., 2023).', rows: [['PFOA',dash(),red('Cancer, hormone disruption, immune suppression'),pct2('73\u201399%','Activated carbon block (Appleman et al., 2014)'),dash()],['PFOS',dash(),red('Cancer, thyroid disruption, developmental harm'),pct2('73\u201399%','Activated carbon block (Dickenson & Higgins, 2016)'),dash()],['PFAS (total)',dash(),red('Forever chemicals \u2014 accumulate in blood and organs'),pct2('Up to 99%','NSF/ANSI 53 & 58 certified ACB filters'),dash()],['Microplastics',dash(),red('Inflammatory response, endocrine disruption'),pct2('>95%','ACB mechanical + adsorption (Zuccarini et al., 2023)'),dash()]] }
    ];

    var accordionHtml = '';
    sections.forEach(function(s, idx) {
      var bodyId = 'ph2-lt-acc-body-' + idx;
      var chevId = 'ph2-lt-acc-chev-' + idx;
      var badgeHtml = s.badge === null && s.title.indexOf('PFAS') !== -1
        ? '<span style="font-size:13px;color:#9ca3af;">\u2014</span>'
        : s.badge
          ? '<span style="background:#fefce8;color:#854d0e;font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px;white-space:nowrap;">' + s.badge + '</span>'
          : '<span style="background:#f0fdf4;color:#16a34a;font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px;white-space:nowrap;">All conforming</span>';
      accordionHtml += '<div style="border:1px solid #e5e7eb;border-radius:12px;margin-bottom:10px;overflow:hidden;"><div data-ph2-lt-acc="' + idx + '" style="display:flex;align-items:center;justify-content:space-between;padding:12px 14px;background:#fff;cursor:pointer;-webkit-tap-highlight-color:transparent;user-select:none;"><div style="display:flex;align-items:center;gap:10px;"><span style="font-size:18px;flex-shrink:0;">' + s.icon + '</span><div><div style="font-size:13px;font-weight:700;color:#111827;">' + s.title + '</div><div style="font-size:10px;color:#9ca3af;margin-top:2px;line-height:1.3;">' + s.sub + '</div></div></div><div style="display:flex;align-items:center;gap:8px;flex-shrink:0;">' + badgeHtml + '<span id="' + chevId + '" style="font-size:20px;color:#9ca3af;font-weight:300;width:20px;text-align:center;line-height:1;">' + (s.open ? '-' : '+') + '</span></div></div><div id="' + bodyId + '" style="display:' + (s.open ? 'block' : 'none') + ';border-top:1px solid #e5e7eb;"><div style="background:#f8fafc;padding:10px 14px;font-size:11px;color:#374151;line-height:1.7;border-bottom:1px solid #e5e7eb;">' + s.note + '</div>' + makeTable(s.rows) + '</div></div>';
    });

    var footerHtml = '<div style="text-align:center;padding:20px 0 16px;font-size:11px;color:#9ca3af;line-height:1.8;">All lab results from independent third-party testing, June 2025.<br>Media removal percentages cited from published peer-reviewed research on filtration technology.<br><br><a href="' + LAB_TEST_PDF_URL + '" target="_blank" rel="noopener" style="color:' + COLOR_BLUE + ';font-weight:600;font-size:12px;text-decoration:none;">View full lab certificate PDF \u2014 Report No. XYS202500786 \u2197</a></div>';

    body.innerHTML = heroHtml + statsHtml + certHtml + noteHtml + sectionLabelHtml + accordionHtml + footerHtml;

    body.addEventListener('click', function(e) {
      var hdr = e.target.closest('[data-ph2-lt-acc]');
      if (!hdr) return;
      var idx = hdr.getAttribute('data-ph2-lt-acc');
      var b = document.getElementById('ph2-lt-acc-body-' + idx);
      var c = document.getElementById('ph2-lt-acc-chev-' + idx);
      if (!b) return;
      var isOpen = b.style.display !== 'none';
      b.style.display = isOpen ? 'none' : 'block';
      if (c) c.textContent = isOpen ? '+' : '-';
    });

    modal.appendChild(body);
    document.body.style.overflow = 'hidden';
    document.body.appendChild(modal);
  }

  window.openPuraLabTest = openLabTestPopup;

  // ═══════════════════════════════════════════════════════════════════════
  // FAQ SECTION (ported from the original script) — founder video, tap-fit
  // quiz, NSF cert popup, shipping/guarantee text, toxic water quiz link.
  // ═══════════════════════════════════════════════════════════════════════

  function openSimpleModal(title, bodyHtml) {
    var existing = document.getElementById('ph2-modal-simple');
    if (existing) existing.parentNode.removeChild(existing);

    var modal = document.createElement('div');
    modal.id = 'ph2-modal-simple';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(17,24,39,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;';

    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:14px;width:100%;max-width:600px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;';

    var header = document.createElement('div');
    header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid ' + COLOR_GRAY_BORDER + ';flex-shrink:0;';
    var titleEl = document.createElement('div');
    titleEl.style.cssText = 'font-size:16px;font-weight:700;color:' + COLOR_NAVY + ';';
    titleEl.textContent = title;
    header.appendChild(titleEl);
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = '\u2715';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.style.cssText = 'border:none;background:none;font-size:18px;color:' + COLOR_GRAY_TEXT + ';cursor:pointer;padding:4px 8px;';
    closeBtn.addEventListener('click', function() { modal.parentNode.removeChild(modal); });
    header.appendChild(closeBtn);
    box.appendChild(header);

    var body = document.createElement('div');
    body.style.cssText = 'flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;';
    body.innerHTML = bodyHtml;
    box.appendChild(body);

    modal.appendChild(box);
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.parentNode.removeChild(modal); });
    document.body.appendChild(modal);
    return body;
  }

  var TAP_QUIZ_OPTIONS = [
    { image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260620_080517_133beb2e-af20-4f37-93f2-9980357bae8d.png?v=1781942816', label: 'Pull-out spray tap', compatible: false },
    { image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260620_080600_cd52ed7c-b0a7-4a3e-987e-4d5177b0b25a.png?v=1781942834', label: 'Sensor / touchless tap', compatible: false },
    { image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260620_080659_df4f57bf-faaf-46c9-9de1-057b24983ff4.png?v=1781942856', label: 'Built-in aerator tap', compatible: false },
    { emoji: '\u2705', label: 'None of these \u2014 my tap is different', compatible: true }
  ];

  function renderQuizQuestion(body) {
    body.innerHTML = '<div style="padding:18px;"><div style="font-size:18px;font-weight:800;color:' + COLOR_NAVY + ';margin-bottom:16px;line-height:1.3;">Does your tap have any of these features?</div><div id="ph2-quiz-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:10px;"></div></div>';
    var grid = body.querySelector('#ph2-quiz-grid');
    TAP_QUIZ_OPTIONS.forEach(function(opt) {
      var card = document.createElement('button');
      card.type = 'button';
      card.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;border:1.5px solid ' + COLOR_GRAY_BORDER + ';border-radius:12px;padding:14px 10px;background:#fff;cursor:pointer;text-align:center;min-height:110px;';
      if (opt.image) { var imgEl = document.createElement('img'); imgEl.src = opt.image; imgEl.alt = opt.label; imgEl.style.cssText = 'width:60px;height:60px;object-fit:contain;'; card.appendChild(imgEl); }
      else if (opt.emoji) { var emojiEl = document.createElement('div'); emojiEl.style.cssText = 'font-size:32px;line-height:1;'; emojiEl.textContent = opt.emoji; card.appendChild(emojiEl); }
      var labelEl = document.createElement('div'); labelEl.style.cssText = 'font-size:13px;font-weight:700;color:' + COLOR_NAVY + ';line-height:1.3;'; labelEl.textContent = opt.label; card.appendChild(labelEl);
      card.addEventListener('click', function() { opt.compatible ? renderQuizResultCompatible(body) : renderQuizResultIncompatible(body); });
      grid.appendChild(card);
    });
  }

  function renderQuizResultCompatible(body) {
    body.innerHTML = '<div style="padding:18px;"><div style="width:40px;height:40px;border-radius:10px;background:' + COLOR_GREEN + ';color:#fff;display:flex;align-items:center;justify-content:center;font-size:20px;font-weight:800;margin-bottom:14px;">\u2713</div><div style="font-size:19px;font-weight:800;color:' + COLOR_NAVY + ';margin-bottom:10px;line-height:1.3;">Great news \u2014 your tap is compatible!</div><div style="font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.6;margin-bottom:18px;">Based on your answer, PuraHome fits your tap. You\u2019ll enjoy cleaner, better-tasting water directly from your faucet \u2014 no tools, no plumber needed.</div><button type="button" id="ph2-quiz-done-btn" style="background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:14px;border:none;border-radius:10px;padding:12px 20px;cursor:pointer;">Got It</button> <a href="#" id="ph2-quiz-restart-1" style="font-size:13px;color:' + COLOR_GRAY_TEXT + ';text-decoration:underline;margin-left:14px;">Restart quiz</a></div>';
    body.querySelector('#ph2-quiz-done-btn').addEventListener('click', function() { var m = document.getElementById('ph2-modal-simple'); if (m) m.parentNode.removeChild(m); });
    body.querySelector('#ph2-quiz-restart-1').addEventListener('click', function(e) { e.preventDefault(); renderQuizQuestion(body); });
  }

  function renderQuizResultIncompatible(body) {
    body.innerHTML = '<div style="padding:18px;"><div style="width:40px;height:40px;border-radius:10px;background:#dc2626;color:#fff;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:800;margin-bottom:14px;">\u2715</div><div style="font-size:19px;font-weight:800;color:' + COLOR_NAVY + ';margin-bottom:10px;line-height:1.3;">Sadly, your tap isn\u2019t compatible</div><div style="font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.6;margin-bottom:18px;">PuraHome isn\u2019t designed to fit this tap style out of the box. Reach out to our support team and we\u2019ll help you find the right fit.</div><a href="https://mypurahome.com/pages/contact" target="_blank" rel="noopener" style="display:inline-block;background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:14px;border-radius:10px;padding:12px 20px;text-decoration:none;">Contact Support</a> <a href="#" id="ph2-quiz-restart-2" style="font-size:13px;color:' + COLOR_GRAY_TEXT + ';text-decoration:underline;margin-left:14px;">Restart quiz</a></div>';
    body.querySelector('#ph2-quiz-restart-2').addEventListener('click', function(e) { e.preventDefault(); renderQuizQuestion(body); });
  }

  function openQuizPopup() {
    var body = openSimpleModal('Will It Fit My Tap?', '');
    renderQuizQuestion(body);
  }

  function openNSFCertPopup() {
    var existing = document.getElementById('ph2-modal-simple');
    if (existing) existing.parentNode.removeChild(existing);
    var modal = document.createElement('div');
    modal.id = 'ph2-modal-simple';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(17,24,39,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;';
    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:14px;width:100%;max-width:680px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;';
    var header = document.createElement('div');
    header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid ' + COLOR_GRAY_BORDER + ';flex-shrink:0;';
    var titleEl = document.createElement('div');
    titleEl.style.cssText = 'display:flex;align-items:center;gap:8px;font-size:16px;font-weight:700;color:' + COLOR_NAVY + ';';
    titleEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#01b778" stroke="#01b778" stroke-width="1.5" stroke-linejoin="round"/></svg>NSF Certification';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = '\u2715';
    closeBtn.style.cssText = 'border:none;background:none;font-size:20px;color:' + COLOR_GRAY_TEXT + ';cursor:pointer;padding:4px 8px;';
    closeBtn.addEventListener('click', function() { document.body.removeChild(modal); });
    header.appendChild(titleEl);
    header.appendChild(closeBtn);
    box.appendChild(header);
    var body = document.createElement('div');
    body.style.cssText = 'flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;';
    var img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/PDP_-_tap_water_filter_2.0_800_x_600_px_1.png?v=1776994202';
    img.alt = 'NSF Certification';
    img.style.cssText = 'width:100%;display:block;';
    body.appendChild(img);
    box.appendChild(body);
    modal.appendChild(box);
    modal.addEventListener('click', function(e) { if (e.target === modal) document.body.removeChild(modal); });
    document.body.appendChild(modal);
  }

  var FAQ_ITEMS = [
    { type: 'founder', q: 'Us vs The Alternatives', open: false },
    { type: 'popup', q: 'Will it fit my tap?', a: 'PuraHome is designed to fit the vast majority of standard kitchen taps, and ships with multiple adapters to cover less common fittings. Not sure about yours?', linkText: 'Take our Tap Fit Quiz', popupHandler: function() { openQuizPopup(); } },
    { type: 'popup', q: 'Is this NSF certified?', a: 'Yes \u2014 PuraHome is NSF certified, independently verified to reduce contaminants to international water quality standards. NSF International is one of the world\u2019s most rigorous third-party testing and certification bodies, recognised by health authorities globally.', linkText: 'View NSF Certificate', popupHandler: function() { openNSFCertPopup(); } },
    { type: 'text', q: 'What about shipping and your guarantee?', a: 'Every order ships free, no minimum spend required. You\u2019re also covered by our 100-night risk-free trial \u2014 if you\u2019re not happy, reach out within that window for a full refund.' },
    { type: 'popup', q: 'Find out how toxic your water is \u2192', a: 'Answer 5 quick questions about your home and water source and we\u2019ll calculate your personalised Toxic Water Score \u2014 plus send you a full breakdown and a discount code.', linkText: 'Take the quiz (60 seconds)', popupHandler: function() { var btn = document.getElementById('pwhq-open'); if (btn) btn.click(); } }
  ];

  function buildFAQ() {
    var container = document.getElementById('ph2-faq');
    if (!container) { console.warn('[PH2] No #ph2-faq container found \u2014 add <div id="ph2-faq"></div> back to the HTML/Liquid tab.'); return; }
    container.innerHTML = '';
    var allRows = [];
    FAQ_ITEMS.forEach(function(item) {
      var row = document.createElement('div');
      row.style.cssText = 'border-bottom:1px solid ' + COLOR_GRAY_BORDER + ';padding:13px 0;';
      var qRow = document.createElement('div');
      qRow.style.cssText = 'display:flex;justify-content:space-between;align-items:center;gap:12px;cursor:pointer;';
      var qText = document.createElement('div');
      qText.style.cssText = 'font-size:14px;font-weight:700;color:' + COLOR_NAVY + ';';
      qText.textContent = item.q;
      qRow.appendChild(qText);
      var toggleIcon = document.createElement('div');
      toggleIcon.style.cssText = 'flex:0 0 auto;font-size:17px;font-weight:700;color:' + COLOR_BLUE + ';transition:transform 0.2s ease;';
      toggleIcon.textContent = '+';
      qRow.appendChild(toggleIcon);
      row.appendChild(qRow);
      var aWrap = document.createElement('div');
      aWrap.style.cssText = 'max-height:0;overflow:hidden;transition:max-height 0.3s ease, margin-top 0.25s ease;';
      var aInner = document.createElement('div');

      if (item.type === 'text') {
        var aText = document.createElement('div');
        aText.style.cssText = 'font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.5;';
        aText.textContent = item.a;
        aInner.appendChild(aText);
      } else if (item.type === 'popup') {
        var popupText = document.createElement('div');
        popupText.style.cssText = 'font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.5;margin-bottom:10px;';
        popupText.textContent = item.a;
        aInner.appendChild(popupText);
        var popupBtn = document.createElement('button');
        popupBtn.type = 'button';
        popupBtn.textContent = item.linkText;
        popupBtn.style.cssText = 'font-size:13px;font-weight:700;color:#fff;background:' + COLOR_BLUE + ';padding:8px 16px;border-radius:8px;border:none;cursor:pointer;';
        popupBtn.addEventListener('click', function() { item.popupHandler(); });
        aInner.appendChild(popupBtn);
      } else if (item.type === 'founder') {
        var founderCard = document.createElement('div');
        founderCard.style.cssText = 'background:#f5f7ff;border:1px solid #e0e4f5;border-radius:14px;padding:16px;';

        var founderIntro = document.createElement('div');
        founderIntro.style.cssText = 'font-size:12px;color:' + COLOR_GRAY_TEXT + ';margin-bottom:12px;';
        founderIntro.textContent = 'A quick breakdown from our co-founder Michael.';
        founderCard.appendChild(founderIntro);

        var founderVideo = document.createElement('video');
        founderVideo.src = 'https://cdn.shopify.com/videos/c/o/v/9aa7545465c74d36b1c0d3df524db685.mov';
        founderVideo.controls = true;
        founderVideo.playsInline = true;
        founderVideo.style.cssText = 'width:100%;border-radius:10px;display:block;background:#000;';
        founderCard.appendChild(founderVideo);

        var founderBlock = document.createElement('div');
        founderBlock.style.cssText = 'display:flex;align-items:center;gap:12px;margin-top:14px;';

        var founderAvatar = document.createElement('img');
        founderAvatar.src = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260703_072758_d033f615-1000-4e0b-92a5-e6ec1da3609b.png?v=1783064330';
        founderAvatar.alt = 'Michael A.';
        founderAvatar.style.cssText = 'width:52px;height:52px;border-radius:50%;object-fit:cover;flex-shrink:0;border:2px solid #e0e4f5;';
        founderBlock.appendChild(founderAvatar);

        var founderInfo = document.createElement('div');
        var founderNameRow = document.createElement('div');
        founderNameRow.style.cssText = 'display:flex;align-items:center;gap:5px;';
        var founderName = document.createElement('span');
        founderName.style.cssText = 'font-size:14px;font-weight:700;color:' + COLOR_NAVY + ';';
        founderName.textContent = 'Michael A.';
        founderNameRow.appendChild(founderName);
        var tick = document.createElement('span');
        tick.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="' + COLOR_BLUE + '"/><polyline points="6 12 10 16 18 8" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
        founderNameRow.appendChild(tick);
        founderInfo.appendChild(founderNameRow);
        var founderTitle = document.createElement('div');
        founderTitle.style.cssText = 'font-size:12px;color:' + COLOR_GRAY_TEXT + ';margin-top:2px;';
        founderTitle.textContent = 'PuraHome Co-Founder';
        founderInfo.appendChild(founderTitle);
        founderBlock.appendChild(founderInfo);
        founderCard.appendChild(founderBlock);

        var spiel1 = document.createElement('p');
        spiel1.style.cssText = 'font-size:13px;color:' + COLOR_NAVY + ';line-height:1.7;margin-top:14px;margin-bottom:0;';
        spiel1.textContent = 'We designed PuraHome because we saw all the benefits of a tap water filter. However, there was never one effective enough for our liking.';
        founderCard.appendChild(spiel1);

        var spiel2 = document.createElement('p');
        spiel2.style.cssText = 'font-size:13px;color:' + COLOR_NAVY + ';line-height:1.7;margin-top:10px;margin-bottom:0;';
        spiel2.innerHTML = '<strong>The result is Australia\u2019s most effective, convenient, and affordable water filter on the market.</strong> Check how it compares against all the other options in this video.';
        founderCard.appendChild(spiel2);

        aInner.appendChild(founderCard);
      }

      aWrap.appendChild(aInner);
      row.appendChild(aWrap);
      var startsOpen = item.open === true;
      var rowState = { aWrap: aWrap, toggleIcon: toggleIcon, open: startsOpen };
      if (startsOpen) {
        aWrap.style.maxHeight = '1200px';
        aWrap.style.marginTop = '10px';
        toggleIcon.style.transform = 'rotate(45deg)';
      }
      allRows.push(rowState);
      qRow.addEventListener('click', function() {
        var wasOpen = rowState.open;
        allRows.forEach(function(r) { r.open = false; r.aWrap.style.maxHeight = '0'; r.aWrap.style.marginTop = '0'; r.toggleIcon.style.transform = 'rotate(0deg)'; });
        if (!wasOpen) { rowState.open = true; aWrap.style.maxHeight = '1200px'; aWrap.style.marginTop = '10px'; toggleIcon.style.transform = 'rotate(45deg)'; }
      });
      container.appendChild(row);
    });
  }

  // ═══════════════════════════════════════════════════════════════════════
  // PRICING (single source of truth)
  // ═══════════════════════════════════════════════════════════════════════

  function applyPricing() {
    var variant = getCurrentVariant();
    if (!variant) return;
    var currency = state.currency;

    // Tab visuals
    var tabToggle = document.getElementById('ph2-tab-toggle');
    var tabOneTime = document.getElementById('ph2-tab-onetime');
    var tabSub = document.getElementById('ph2-tab-sub');
    var tabSubPct = document.getElementById('ph2-tab-sub-pct');
    if (tabToggle) tabToggle.classList.toggle('sub-active', state.subscriptionActive);
    if (tabOneTime) tabOneTime.classList.toggle('active', !state.subscriptionActive);
    if (tabSub) tabSub.classList.toggle('active', state.subscriptionActive);
    if (tabSubPct) tabSubPct.textContent = computeMaxSavingsPct() + '%';

    // Dynamic strip swap
    var apContent = document.getElementById('ph2-afterpay-content');
    var autoshipText = document.getElementById('ph2-autoship-reassurance');
    var apSupported = AFTERPAY_CURRENCIES.indexOf(currency) !== -1;
    if (apContent) apContent.classList.toggle('ph2-hidden', state.subscriptionActive || !apSupported);
    if (autoshipText) autoshipText.classList.toggle('ph2-hidden', !state.subscriptionActive);

    // Determine what's "active" — a card or the bundle — for hero price/day + heading + ATC
    var activeBasePrice, activeComparePrice, activeDays, activeLabel;
    if (state.bundle.selected) {
      var bv = state.bundle.variants[state.bundle.option];
      activeBasePrice = bv ? bv.price : 0;
      activeComparePrice = bv ? bv.compare_price : null;
      activeDays = state.bundle.option === '1yr' ? 365 : 182;
      activeLabel = 'Bundle \u2014 ' + (state.bundle.option === '1yr' ? '1-Year Supply' : '6-Month Supply');
    } else {
      var meta = VARIANT_META[variant.title] || { days: 365, label: variant.title };
      activeBasePrice = variant.price;
      activeComparePrice = variant.compare_price;
      activeDays = meta.days;
      activeLabel = meta.label;
    }
    var activeEffectivePrice = getEffectivePrice(activeBasePrice);

    var heroEl = document.getElementById('ph2-perday-hero');
    var heroSubEl = document.getElementById('ph2-perday-sub');
    if (heroEl) heroEl.textContent = formatPerDay(activeEffectivePrice, activeDays, currency);
    if (heroSubEl) heroSubEl.textContent = 'for filtered water \u2014 less than bottled water';

    var apAmountEl = document.getElementById('ph2-afterpay-amount');
    if (apAmountEl) apAmountEl.textContent = formatMoney(activeEffectivePrice / 4, currency);

    var headingValueEl = document.getElementById('ph2-supply-heading-value');
    if (headingValueEl) headingValueEl.textContent = activeLabel;

    // ATC button text
    var atcBtn = document.getElementById('ph2-atc-btn');
    if (atcBtn && !atcBtn.disabled) {
      var savingsPct = pctOff(activeComparePrice, activeEffectivePrice);
      atcBtn.innerHTML = 'Protect My Home &amp; Save <span class="ph2-atc-pct">' + savingsPct + '%</span>';
    }

    // Per-card visuals
    state.variants.forEach(function(v) {
      var card = document.querySelector('.ph2-card[data-variant-id="' + v.id + '"]');
      if (!card) return;
      var vMeta = VARIANT_META[v.title] || { days: 365 };
      var isSoldOut = !v.available;
      var vEffPrice = getEffectivePrice(v.price);

      var sublabelEl = card.querySelector('.ph2-card-sublabel');
      if (sublabelEl) sublabelEl.textContent = state.subscriptionActive ? vMeta.sublabelAutoShip : vMeta.sublabelOneTime;

      var compareEl = card.querySelector('.ph2-card-compare');
      var priceEl = card.querySelector('.ph2-card-price');
      var perDayEl = card.querySelector('.ph2-card-perday');
      var pctPill = card.querySelector('.ph2-pct-pill');

      if (isSoldOut) {
        // Keep the original price legible (per Joel's reference) rather than fully blurring it.
        if (compareEl) { compareEl.textContent = formatMoneyNoDecimal(v.compare_price || v.price, currency); compareEl.style.display = v.compare_price ? '' : 'none'; }
        if (priceEl) priceEl.textContent = formatMoneyNoDecimal(v.price, currency);
        if (perDayEl) perDayEl.textContent = formatPerDay(v.price, vMeta.days, currency);
      } else {
        if (compareEl) {
          if (v.compare_price && v.compare_price > vEffPrice) {
            compareEl.textContent = formatMoneyNoDecimal(v.compare_price, currency);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (priceEl) priceEl.textContent = formatMoneyNoDecimal(vEffPrice, currency);
        if (perDayEl) perDayEl.textContent = formatPerDay(vEffPrice, vMeta.days, currency);
        if (pctPill) pctPill.textContent = pctOff(v.compare_price, vEffPrice) + '% OFF';
      }

      var scarcityData = VARIANT_SCARCITY[v.title]; // kept for potential future use; bars removed from UI
    });

    // Bundle card visuals
    var bundleCard = document.getElementById('ph2-bundle-card');
    var bundleCheck = document.getElementById('ph2-bundle-check');
    if (bundleCard) bundleCard.classList.toggle('ph2-selected', state.bundle.selected);
    if (bundleCheck) bundleCheck.classList.toggle('ph2-checked', state.bundle.selected);
    document.querySelectorAll('.ph2-bundle-opt').forEach(function(opt) {
      opt.classList.toggle('ph2-active', opt.getAttribute('data-opt') === state.bundle.option);
    });

    var bv2 = state.bundle.variants[state.bundle.option];
    if (bv2) {
      var bundleEff = getEffectivePrice(bv2.price);
      var bundleCompareEl = document.getElementById('ph2-bundle-compare');
      var bundlePriceEl = document.getElementById('ph2-bundle-price');
      var bundlePctEl = document.getElementById('ph2-bundle-pct-pill');

      if (bundleCompareEl) {
        if (bv2.compare_price && bv2.compare_price > bundleEff) {
          bundleCompareEl.textContent = formatMoneyNoDecimal(bv2.compare_price, currency);
          bundleCompareEl.style.display = '';
        } else {
          bundleCompareEl.style.display = 'none';
        }
      }
      if (bundlePriceEl) bundlePriceEl.textContent = formatMoneyNoDecimal(bundleEff, currency);
      if (bundlePctEl) bundlePctEl.textContent = pctOff(bv2.compare_price, bundleEff) + '% OFF';

      var bundleListEl = document.getElementById('ph2-bundle-list');
      if (bundleListEl) {
        var filterCount = state.bundle.option === '1yr' ? 4 : 2;
        var cadenceMonths = state.bundle.option === '1yr' ? 12 : 6;
        var items = [
          'Filter System + ' + filterCount + ' Filters',
          '360\u00b0 Aerator',
          'Shower Filter + ' + filterCount + ' Filters'
        ];
        if (state.subscriptionActive) {
          items.push('Ships every ' + cadenceMonths + ' months');
        }
        bundleListEl.innerHTML = items.map(function(t) { return '<li>' + t + '</li>'; }).join('');
      }
    }

    // URL + hidden form inputs for the base product path (bundle handled separately in cart add)
    if (!state.bundle.selected) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    bridgeChangeListeners.forEach(function(cb) {
      try { cb(); } catch (e) { console.error('[PH2] Bridge listener error \u2014', e); }
    });
  }

  // ═══════════════════════════════════════════════════════════════════════
  // BUNDLE PRODUCT FETCH
  // ═══════════════════════════════════════════════════════════════════════

  function fetchBundleProduct(callback) {
    // window.bundleVariantData, if present, comes from a Liquid block using
    // all_products['handle'] and gives currency-corrected prices — same pattern
    // as window.variantData for the main product. Falls back to raw fetch prices
    // (store base currency only) if that block hasn't been added yet.
    var bundlePriceMap = {};
    if (window.bundleVariantData && Array.isArray(window.bundleVariantData)) {
      window.bundleVariantData.forEach(function(v) { bundlePriceMap[v.id] = v; });
    }

    fetch('/products/' + BUNDLE_PRODUCT_HANDLE + '.js')
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(product) {
        state.bundle.product = product;
        state.bundle.images = (product.images || []).map(function(img) {
          return typeof img === 'string' ? img : img.src;
        });
        state.bundle.title = product.title;
        state.bundle.description = product.description || product.body_html || '';
        (product.variants || []).forEach(function(v) {
          var t = (v.title || '').toLowerCase();
          var p = bundlePriceMap[v.id] || {};
          var entry = {
            id: v.id,
            price: p.price !== undefined ? p.price : v.price / 100,
            compare_price: p.compare_price !== undefined ? p.compare_price : (v.compare_at_price ? v.compare_at_price / 100 : null),
            available: v.available !== false
          };
          if (t.indexOf('12') > -1 || t.indexOf('1 year') > -1 || t.indexOf('1yr') > -1) {
            state.bundle.variants['1yr'] = entry;
          } else if (t.indexOf('6') > -1) {
            state.bundle.variants['6mo'] = entry;
          }
        });
        var img = document.getElementById('ph2-bundle-img');
        if (img && product.featured_image) img.src = product.featured_image;
        callback();
      })
      .catch(function(err) {
        console.error('[PH2] Could not load bundle product "' + BUNDLE_PRODUCT_HANDLE + '" \u2014', err);
        console.error('[PH2] The bundle option will not function correctly until BUNDLE_PRODUCT_HANDLE points to a real product. See setup checklist.');
        callback();
      });
  }

  // ═══════════════════════════════════════════════════════════════════════
  // ADD TO CART
  // ═══════════════════════════════════════════════════════════════════════

  function getSellingPlanForCurrentSelection() {
    if (!state.subscriptionActive) return null;
    if (state.bundle.selected) {
      return BUNDLE_SELLING_PLANS[state.bundle.option] || null;
    }
    var variant = getCurrentVariant();
    if (!variant) return null;
    return SUBSCRIPTION_SELLING_PLANS[variant.title] || null;
  }

  function performAddToCart() {
    var items;
    if (state.bundle.selected) {
      var bv = state.bundle.variants[state.bundle.option];
      if (!bv) return Promise.reject(new Error('Bundle variant not loaded'));
      items = [{ id: bv.id, quantity: 1 }];
    } else {
      var variant = getCurrentVariant();
      if (!variant) return Promise.reject(new Error('No variant selected'));
      items = [{ id: variant.id, quantity: 1 }];
    }
    var sellingPlanId = getSellingPlanForCurrentSelection();
    if (sellingPlanId) items[0].selling_plan = sellingPlanId;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(result) {
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        return tryOpenCartDrawer().then(function(opened) {
          if (!opened) window.location.href = '/cart';
          return result;
        });
      });
  }

  function tryOpenCartDrawer() {
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    return fetch('/?section_id=cart-drawer')
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector('cart-drawer');
        var existingDrawer = document.querySelector('cart-drawer');
        if (!freshDrawer || !existingDrawer) return false;
        existingDrawer.outerHTML = freshDrawer.outerHTML;
        var newDrawer = document.querySelector('cart-drawer');
        if (!newDrawer) return false;
        if (typeof newDrawer.open === 'function') newDrawer.open();
        else if (typeof newDrawer.show === 'function') newDrawer.show();
        else { newDrawer.setAttribute('open', ''); newDrawer.classList.add('is-open', 'active', 'drawer--open'); }
        return true;
      })
      .catch(function(err) {
        console.error('[PH2] Cart drawer refresh failed \u2014', err);
        var iconCandidates = ['#CartDrawer-Toggle', '.js-drawer-open-cart', '#cart-icon-bubble', '.site-header__cart', 'a.site-header__icon--cart', '.header__icon--cart', '[data-cart-icon]'];
        for (var j = 0; j < iconCandidates.length; j++) {
          var icon = document.querySelector(iconCandidates[j]);
          if (icon) { icon.click(); return true; }
        }
        return false;
      });
  }

  function handleAddToCartClick() {
    var btn = document.getElementById('ph2-atc-btn');
    if (!btn) return;
    var originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    performAddToCart()
      .then(function() {
        btn.disabled = false;
        applyPricing(); // restores correct "Protect My Home & Save X%" text
      })
      .catch(function(err) {
        console.error('[PH2] Add to cart failed \u2014', err);
        btn.disabled = false;
        btn.innerHTML = originalHtml;
        alert('Something went wrong adding this to your cart \u2014 please try again.');
      });
  }

  // ═══════════════════════════════════════════════════════════════════════
  // BRIDGE — consumed by the GemPages Script-tab snippet to sync the native
  // variant-id input and hide the dynamic checkout button when the bundle
  // (a different product) is selected, since that button can't check it out.
  // ═══════════════════════════════════════════════════════════════════════

  window.PuraHomeOffer = {
    isReady:           function() { return state.variants.length > 0; },
    getCurrentVariant: getCurrentVariant,
    getCurrency:       function() { return state.currency; },
    isBundleSelected:  function() { return state.bundle.selected; },
    selectVariant: function(id) {
      var container = document.getElementById('ph2-cards');
      state.currentVariantId = id;
      state.bundle.selected = false;
      if (container) highlightCard(id, container);
      applyPricing();
    },
    addToCart: performAddToCart,
    onChange: function(callback) {
      if (typeof callback === 'function') bridgeChangeListeners.push(callback);
    }
  };

  // ═══════════════════════════════════════════════════════════════════════
  // INIT
  // ═══════════════════════════════════════════════════════════════════════

  function init() {
    var container = document.getElementById('ph2-cards');
    if (!container) return;

    injectStyles();
    var currency = getCurrency();
    var handle = detectProductHandle();
    console.log('[PH2] Using product handle:', handle);

    buildPriceBlock();
    buildSupplyHeading();

    var ctaContainer = document.getElementById('ph2-cta');
    if (ctaContainer) ctaContainer.innerHTML = '';
    buildStockBanner();
    buildBundleOption();
    buildAtcButton();
    buildTrustBadges();
    buildFAQ();

    fetchBundleProduct(function() {
      // Re-run pricing once bundle data is in, in case cards already rendered first.
      if (state.variants.length > 0) applyPricing();
    });

    fetch('/products/' + handle + '.js')
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(product) {
        var priceMap = {};
        if (window.variantData && Array.isArray(window.variantData)) {
          window.variantData.forEach(function(v) { priceMap[v.id] = v; });
        }
        var merged = product.variants.map(function(v) {
          var p = priceMap[v.id] || {};
          return {
            id: v.id,
            title: v.title,
            featured_image: v.featured_image,
            available: v.available !== false,
            price: p.price !== undefined ? p.price : v.price / 100,
            compare_price: p.compare_price !== undefined ? p.compare_price : (v.compare_at_price ? v.compare_at_price / 100 : null),
          };
        });
        buildCards(merged, currency, container);
      })
      .catch(function(err) {
        console.error('[PH2] Failed to fetch /products/' + handle + '.js \u2014', err);
        container.innerHTML = '<div style="color:#999;font-size:13px;padding:12px 0">Could not load options. Please refresh.</div>';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();